import styles from './index.module.css';
import { Card, AutoComplete } from 'antd';
import React, { useState } from 'react';
import hitches, { Hitch, Hitches } from '../../services/apps/hitches';
import { useIntl } from 'react-intl';

const LinkAnotherAppCard = ({
  otherHitch,
  onSelect,
}: {
  otherHitch?: Hitch;
  onSelect: (selected?: string) => void;
}): JSX.Element => {
  const { formatMessage } = useIntl();
  const [autoCompleteValue, setAutocompleteValue] = useState<string>();

  return (
    <Card className={styles.info}>
      <Card.Meta
        title={formatMessage({
          defaultMessage: 'Choose an app',
          description: 'integrations/choose/title',
        })}
        description={
          <AutoComplete
            allowClear
            onChange={(value) => {
              setAutocompleteValue(value);
              if (!value) {
                onSelect();
              }
            }}
            onSelect={(value) => {
              if (Hitches[value]?.id) {
                onSelect(Hitches[value].id);
                // push({
                //   pathname: `/hitch/[...id]`,
                //   query: {
                //     id: [otherHitch ? otherHitch.id : 'none', Hitches[value].id],
                //   },
                // });
              }
            }}
            value={autoCompleteValue}
            style={{ width: 200 }}
            options={hitches
              .filter(({ id }) => (otherHitch ? id !== otherHitch.id : true))
              .map(({ id, name }) => ({ value: id, label: name }))}
            placeholder={formatMessage({
              defaultMessage: 'Search',
              description: 'integration/search/placeholder',
            })}
            filterOption={(inputValue, option) => {
              return (
                !!option?.label &&
                (option.label as string).toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
              );
            }}
          />
        }
      />
      {/* <Row align="middle" justify="center" style={{ height: '50px' }}>
        <h1>Choose an app</h1>
      </Row> */}
      {/* <Row align="middle" justify="center" style={{ height: '50px' }}>
        <ApiOutlined style={{ fontSize: '40px' }} />
      </Row>
      <Row align="middle" justify="center" style={{ textAlign: 'center' }}>
        <p>Choose the app you want to integrate with</p>
      </Row> */}
    </Card>
  );
};
export default LinkAnotherAppCard;
